import React, { useEffect, useState } from 'react'
import { Border } from '../RecogntionAdmin/styles'
import { AdminCloseIcon, MonthlyCaloriesIcon } from '../../utils/icons'
import { StyledModal } from '../../containers/Education/styles'
import { CalendarHeader } from '../common/CommonModal/style'
import PropTypes from 'prop-types'
import { DisableEnableButton, GoalTableContainer, HeaderContainer, TypeContainer } from './styles'
// import { useHistory } from "react-router-dom";
import { commaSeperator, fetchApi } from '../../utils/methods'
import { toast } from 'react-toastify'
import { GetStartPointsByType, PostMonthlyGoalChallenge } from '../../redux/constants/apiConstants'
import { ImageUrl } from '../../utils/constants'


function MonthlyGoalChallengePopup({show,onClose,challengeId,refreshAnnouncements,activityType,setCurrentSlide}) {
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [startPointData, setStartPointData] = useState(null);
  const [isJoining, setIsJoining] = useState(false);

  window.console.log("activityType", activityType)
  // const history = useHistory();

  useEffect(() => {
    if (activityType) {
      FetchStartingPointsData();
    }
  }, [activityType]);


  const FetchStartingPointsData = async()=>{
    try {
      const res = await fetchApi(`${GetStartPointsByType}/${activityType}`, "GET");
      if(res.status === 'success'){
        setStartPointData(res.data)
       
      }else{
        toast.error((res?.data?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
  }

  window.console.log("selectedLevel", selectedLevel)

  const joinChallenge = async () => {
    if (isJoining || selectedLevel === null) return; 
    setIsJoining(true);
    const payload = {
      monthly_gaol_challenge_id: challengeId,
      level_id: selectedLevel,
    };

    try {
      const res = await fetchApi(PostMonthlyGoalChallenge, "POST", payload);

      if (res.status === "success") {
        // SuccessToastEvent();
        toast.success(res?.data?.message);
        refreshAnnouncements();
        setCurrentSlide(1);
        onClose();
        // history.push("/challenges/monthly-goal-challenge")

      } else {
        toast.error(res?.data?.message);
        setIsJoining(false);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
      setIsJoining(false);
    } 
  };


  
  const isDisabled = selectedLevel === null || isJoining;

  return (
    <StyledModal show={show} width={'600px'} isPadding={"20px"}>
      <div className="modal-content-padding">
        <CalendarHeader>
          <div className="left-content">
            <div>{"Choose Your Starting Point"}</div>
          </div>
          <div className="close-icon" onClick={()=>onClose()}>
            {AdminCloseIcon()}
          </div>
        </CalendarHeader>
        <Border background={'#EFEFEF'} height={'0.75px'}/>
        <HeaderContainer>
          <TypeContainer>{MonthlyCaloriesIcon()}</TypeContainer>
          <div className='title'>There’s no right or wrong level. Choose what feels realistic for <br/> you this month.</div>
        </HeaderContainer>

        <GoalTableContainer>
          <div className="table-header">
            <span className="heading firstColumn">Level</span>
            <span className="heading">Daily Goal</span>
            <span className="heading lastColumn">Monthly Goal</span>
          </div>
        
          {startPointData?.map((item) => (
            <div
              key={item.id}
              className={`table-row ${selectedLevel === item.id ? "selected" : ""}`}
              onClick={() => setSelectedLevel(item.id)}
            >
              <div className="level">
              
                <img src={ImageUrl +"/"+ item?.icon} className="icon"></img>
                <span>{item?.level_name}</span>
              </div>
              <span>{commaSeperator(item?.daily_goal_steps)} {item?.activity_type}</span>
              <span className="lastColumn">{commaSeperator(item?.monthly_target_steps)} {item?.activity_type}</span>
            </div>
          ))}
        </GoalTableContainer>

        <Border margin={"16px 0 16px 0"} background={'#EFEFEF'} height={'0.75px'}/>

        <DisableEnableButton
          onClick={!isDisabled ? joinChallenge : null}
          isCursor={!isDisabled} 
          active={!isDisabled}
          disabledColor={isDisabled ? "#989898" : "#FEFEFE"}
          disabledBg={isDisabled ? "#EFEFEF" : "#DA6C74"}
          margin={"20px auto 0 auto"}>
         Start My Challenge
        </DisableEnableButton>
      </div>
    </StyledModal>
  )
}

MonthlyGoalChallengePopup.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose:PropTypes.func,
  challengeId: PropTypes.number,
  refreshAnnouncements: PropTypes.func,
  activityType: PropTypes.string,
  setCurrentSlide: PropTypes.func
};
  


export default MonthlyGoalChallengePopup
